package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import at.theatervogelweide.admin.web.Route
import org.jetbrains.compose.web.dom.A

/** A link to [route] inside the app; with a modifier key held, the browser opens it in a new tab instead. */
@Composable
fun RouteLink(route: Route, onNavigate: (Route) -> Unit, vararg classNames: String, content: @Composable () -> Unit) {
    A(route.path, {
        classes(*classNames)
        onClick { event ->
            if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {
                event.preventDefault()
                onNavigate(route)
            }
        }
    }) { content() }
}
